import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { NotificationItem } from '../../../core/models/notification-center.model';
import { normalizeDateStringForPipe } from '../../../core/utils/date.utils';

@Component({
  selector: 'app-notification-item',
  standalone: true,
  imports: [],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  readonly item = input.required<NotificationItem>();

  readonly open = output<NotificationItem>();

  onOpen(): void {
    this.open.emit(this.item());
  }

  formatCreatedAt(value: string): string {
    if (!value) return '';

    const normalized = normalizeDateStringForPipe(value);
    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return new Intl.DateTimeFormat('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }
}

